import axios from 'axios'

window.axios = axios
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
window.axios.defaults.baseURL = process.env.VUE_APP_API_URL

process.env.NODE_TLS_REJECT_UNAUTHORIZED = '0';